/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Import_As_MarkersInputs */



/**
* | output |
* | --- |
* | "Import as Markers" |
*
* @param {Ocr_Import_As_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_import_as_markers = /** @type {((inputs?: Ocr_Import_As_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Import_As_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer comme marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Als Marker importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa come marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортировать как маркеры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar como marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入为标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーとしてインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर के रूप में आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar como marcadores")
	return /** @type {LocalizedString} */ ("Import as Markers")
});